<template>
  <div>
    <data-tables :data="rows">
      <el-table-column prop="username" label="使用者帳號">
        <div slot-scope="{row}">
          <div v-if="row.new === true">
            <el-input placeholder="帳號" v-model="newUser.username" size="mini"></el-input>
          </div>
          <span v-else>{{row.username}}</span>
        </div>
      </el-table-column>
      <el-table-column prop="Password" label="密碼">
        <div slot-scope="{row}">
          <div v-if="row.new === true">
            <el-input type="password" placeholder="密碼" v-model="newUser.password" size="mini"></el-input>
          </div>
          <span v-else>******</span>
        </div>
      </el-table-column>

      <el-table-column prop="Actions" label="" width="64">
        <div slot-scope="{row}">
          <el-button type="warning" icon="el-icon-plus" circle size="small"
            v-if="row.new === true" @click="createUser" title="新增使用者"></el-button>
          <el-button type="danger" icon="el-icon-delete" circle size="small"
            v-else @click="deleteUser(row)" title="刪除使用者"></el-button>
        </div>
      </el-table-column>
    </data-tables>
  </div>
</template>

<script>
import axios from 'axios';
import { auth } from '../../firestore';
import { DataTables } from "vue-data-tables";

export default {
  name: 'PosUserMngmt',
  components: {
    DataTables
  },
  props: {
    shopId: Number,
    userType: {
      type: String,
      default: 'gaa'
    }
  },

  mounted() {

  },

  methods: {
    fetchUsers() {
      console.log(`Fetching QC-POS users for shop ${this.shopId}...`);
      axios.get(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcpos/users?shopId=${this.shopId}`)
      .then(response => {
        this.users = response.data;
      })
      .catch(err => {
        console.error(`fetchUsers failed`, err);
      });
    },

    createUser() {
      axios.post(
        `${process.env.VUE_APP_APIHOST}/${this.userType}/qcpos/signup`,
        {
          "username": this.newUser.username, "password": this.newUser.password,
          "shopId": this.shopId
        }
      )
      .then(response => {
        this.$message({
          type: 'success', message: `新增成功！（${this.newUser.username}）`
        });
        this.newUser = {username: '', password: ''};
        this.fetchUsers();
      })
      .catch(err => {
        console.error(`Cannot create user`, this.newUser, err);
        this.$message.error(`無法新增使用者（${this.newUser.username}）`);
      });
    },
    deleteUser(user) {
      axios.delete(`${process.env.VUE_APP_APIHOST}/${this.userType}/qcpos/users/${user.username}`)
      .then(response => {
        this.$message({
          type: 'success', message: `${user.username}已刪除。`
        });
        this.fetchUsers();
      })
      .catch(err => {
        console.error(`Cannot delete user`, user.username, err);
        this.$message.error(`無法刪除使用者（${user.username}）`);
      });
    }
  },

  data() {
    return {
      users: [],

      newUser: {
        username: '', password: ''
      }
    }
  },

  computed: {
    rows() {
      if (this.users.length < 100) {//FIXME: Limit max user count at 100. Virtually unlimited~
        return this.users.concat({
          new: true,
          uid: '新增使用者'
        });
      }
      return this.users;
    }
  },

  watch: {
    shopId: {
      immediate: true,
      handler(id) {
        if (id >= 0) {
          this.fetchUsers()
        } 
      }
    }
  }
}
</script>

<style scoped>

</style>